import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import moment from "moment";
import React, { Component } from 'react';
import { SingleDatePicker } from "react-dates";
import DebounceInput from "react-debounce-input";
import EventBus from "../../../../common/EventBus.js";
import SectionWrapper from "../../sectionwrapper.component.jsx";
import FileGalleryContentInput from '../file-gallery/input.component.jsx';
import ImageGalleryContentInput from "../image-gallery/input.component.jsx";

class CustomFormContentSection extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            className: this.props.className || '',
            section: this.props.section || null,
            variables: this.props.variables || null,
            editable: this.props.editable || false,
            edition: this.props.edition || false,
            isPdf: this.props.isPdf || false,
            onEdit: this.props.onEdit || function () { },
            id: this.props.id || '',
            customField: null,
            selectedCustomField: {
                customFieldId: "",
                customFieldValue: "",
                customFieldType: "",
            },
        }
    }

    UNSAFE_componentWillMount() {
        this.updateCustomField()
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            className: nextProps.className || '',
            section: nextProps.section || null,
            variables: nextProps.variables || null,
            isPdf: nextProps.isPdf || false,
            id: nextProps.id || '',
        }, this.updateCustomField)
    }

    updateCustomField() {
        if (this.state.section && this.state.section.attributes.content) {
            const customField = this.state.section.attributes.content.customField

            const projectCustomFieldValues = (this.state.variables && this.state.variables.project && this.state.variables.project.customFieldValues)
                ? this.state.variables.project.customFieldValues : {}

            const contactCustomFieldValues = this.state.variables.customer?.customFieldValues ?? {}

            let option = {}
            if (this.state.section.attributes.content.customFieldType == "contact") {
                option = contactCustomFieldValues[customField.id]
            } else {
                option = projectCustomFieldValues[customField.id]
            }

            this.setState({
                customField,
                selectedCustomField: {
                    customFieldId: customField.id,
                    customFieldValue: this.state.selectedCustomField.customFieldValue || option || "",
                    customFieldType: this.state.section.attributes.content.customFieldType
                }
            })
        }
    }

    saveCustomFieldValue() {
        if (!this.state.variables || this.state.variables.document.type == 'price-list') {
            return
        }

        if (this.state.variables && this.state.variables.project && this.state.variables.project.id && this.state.selectedCustomField.customFieldId && this.state.selectedCustomField.customFieldType != "contact") {
            AppContext.getApiClient().patch(`/proposals/${this.state.variables.hash}/projects/${this.state.variables.project.id}`, {
                customFieldValues: {
                    [this.state.selectedCustomField.customFieldId]: this.state.selectedCustomField.customFieldValue,
                },
            }).then(res => { })
        }

        if (this.state.variables && this.state.variables.project && this.state.variables.project.id && this.state.selectedCustomField.customFieldId && this.state.selectedCustomField.customFieldType == "contact") {
            AppContext.getApiClient().patch(`/proposals/${this.state.variables.hash}/contacts/${this.state.variables.customer.contactId}`, {
                customFieldValues: {
                    [this.state.selectedCustomField.customFieldId]: this.state.selectedCustomField.customFieldValue,
                },
            }).then(res => { })
        }
    }

    dispatchCustomFieldValueChange() {
        let selectedCustomField = Object.assign({}, this.state.selectedCustomField)
        if (this.state.customField.attributes.fieldType === "date") {
            selectedCustomField.customFieldValue = selectedCustomField.customFieldValue ? selectedCustomField.customFieldValue.format() : ''
        }
        if (this.state.selectedCustomField.customFieldType != "contact") {
            EventBus.dispatch(EventBus.TopicCustomFormFieldChanged, selectedCustomField)
        }
        this.saveCustomFieldValue()
    }

    handleFormChange(event) {
        const target = event.target
        let name = target.name.split("_")[0]
        let selectedCustomField = Object.assign({}, this.state.selectedCustomField)

        selectedCustomField[name] = target.value
        this.setState({
            selectedCustomField: selectedCustomField,
        }, this.dispatchCustomFieldValueChange)
    }

    colSize() {
        const colSize = this.state.section.attributes.content.customFieldColSize
        if (colSize)
            return 'col-' + colSize

        if (this.state.customField) {
            switch (this.state.customField.attributes.fieldType) {
                case "text": return 'col-6'
                case "multi-line-text": return 'col-12'
                case "single-choice": return 'col-12'
                default: return 'col-4'
            }
        }

        return 'col-4'
    }

    renderCustomField() {
        if (this.state.customField) {
            let customFieldId = this.state.section.attributes.content.customField.id
            let customFieldType = this.state.section.attributes.content.customField.attributes.customFieldType

            switch (this.state.customField.attributes.fieldType) {
                case "image":
                    const projectCustomFieldRelations = (this.state.variables && this.state.variables.project && this.state.variables.project.customFieldRelations)
                        ? this.state.variables.project.customFieldRelations : {}
                    return <ImageGalleryContentInput
                        hideLabels={true}
                        hideImagesPerRow={true}
                        loadedImages={projectCustomFieldRelations[customFieldId]}
                        disabled={this.state.editable}
                        accountId={this.state.variables.quote.accountId}
                        onChange={(imageIds) => {
                            let selectedCustomField = Object.assign({}, this.state.selectedCustomField)
                            selectedCustomField.customFieldValue = JSON.stringify(imageIds)
                            this.setState({
                                selectedCustomField
                            }, this.dispatchCustomFieldValueChange)
                        }
                        } />

                case "text": return <DebounceInput
                    minLength={0}
                    debounceTimeout={500}
                    onChange={(event) => this.handleFormChange(event)}
                    autoComplete="off"
                    name={"customFieldValue" + "_" + customFieldId + "_" + customFieldType}
                    value={this.state.selectedCustomField.customFieldValue}
                    id="customFieldValue"
                    type="text"
                    className="form-control"
                />

                case "multi-line-text": return <DebounceInput
                    element="textarea"
                    rows="3"
                    minLength={0}
                    debounceTimeout={500}
                    onChange={(event) => this.handleFormChange(event)}
                    autoComplete="off"
                    name={"customFieldValue" + "_" + customFieldId + "_" + customFieldType}
                    value={this.state.selectedCustomField.customFieldValue}
                    id="customFieldValue"
                    type="text"
                    className="form-control"
                />
                case "date": return <SingleDatePicker
                    small
                    block
                    displayFormat="LL"
                    focused={this.state.focused}
                    isOutsideRange={() => false}
                    onDateChange={(date) => {
                        let selectedCustomField = Object.assign({}, this.state.selectedCustomField)
                        selectedCustomField.customFieldValue = date || ''

                        this.setState({
                            selectedCustomField,
                        }, this.dispatchCustomFieldValueChange)
                    }}
                    onFocusChange={({ focused }) => this.setState({ focused })}
                    date={this.state.selectedCustomField.customFieldValue ? moment(this.state.selectedCustomField.customFieldValue) : ''}
                    numberOfMonths={1}
                />
                case "single-choice":
                    if (this.state.customField.attributes?.metadata?.length > 0) {
                        return <div key={customFieldId}>
                            {
                                this.state.customField.attributes.metadata.map((option, index) => {
                                    return <label className="d-block">
                                        <input
                                            name={"customFieldValue" + "_" + customFieldId + "_" + customFieldType}
                                            value={option}
                                            onChange={(event) => this.handleFormChange(event)}
                                            key={"customFieldValue" + "_" + customFieldId + "_" + index + "_" + customFieldType}
                                            id={"customFieldValue" + "_" + customFieldId + "_" + index + "_" + customFieldType}
                                            type="radio"
                                            checked={option === this.state.selectedCustomField.customFieldValue}
                                        />
                                        <span className="ml-1">{option}</span>
                                    </label>
                                })
                            }
                        </div>
                    }
                case "file":
                    const { project } = this.state.variables
                    const projectCustomFieldFileRelations = project?.customFieldRelations || {}
                    const selectedCustomFieldDef = project?.customFieldDefinitions?.find(field => field.id === customFieldId) || {}
                    const acceptedFileTypes = selectedCustomFieldDef?.attributes?.acceptedFileType
                    const acceptedFileTypeArray = acceptedFileTypes ? Object.values(acceptedFileTypes) : ''
                    return <FileGalleryContentInput
                        hideLabels={true}
                        accountId={this.state.variables.quote.accountId}
                        onChange={(fileIds) => {
                            const selectedCustomField = {
                                ...this.state.selectedCustomField,
                                customFieldValue: JSON.stringify(fileIds)
                            }
                            this.setState({
                                selectedCustomField
                            }, this.dispatchCustomFieldValueChange)
                        }}
                        files={projectCustomFieldFileRelations[customFieldId]}
                        fileTypes={acceptedFileTypeArray}
                    />
                default:
                    return ''
            }
        }

        return ''
    }

    render() {
        if (!this.state.section) {
            return <div />
        }

        return (
            <SectionWrapper
                id={this.state.id}
                section={this.state.section}
                onEdit={this.state.onEdit}
                editable={this.state.editable}
                variables={this.state.variables}
            >
                <div className={'py-2 pl-4 pr-4 ' + this.colSize()}>
                    <div className={'row px-3 flex-column'}>
                        <label><b>{this.state.section.attributes.content.customFieldLabel}</b>{
                            this.state.section.attributes.content.customFieldRequired &&
                            <span className="text-danger">*</span>}</label>

                        {this.renderCustomField()}
                    </div>
                </div>
            </SectionWrapper>
        );
    }
}

export default CustomFormContentSection


// WEBPACK FOOTER //
// ./src/template/sections/content/custom-form/section.component.jsx